module.exports = __webpack_public_path__ + "static/img/redmon_01@2x.b59c07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redmon_01@2x.png
// module id = RjJr
// module chunks = 0